import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const AddToCartAPI = createApi({
  reducerPath: "AddToCartAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: BaseUrl,

    prepareHeaders: (headers, { getState }) => {
      const accessToken = localStorage.getItem("access_token");
      const cartToken = localStorage.getItem("cartToken");

      // If the user is logged in, add the access token to the headers
      if (accessToken) {
        headers.set("Authorization", `Bearer ${accessToken}`);
      }

      // If the user is a guest, always pass the Cart-Token header, even if it's null
      if (!accessToken) {
        headers.set("Cart-Token", cartToken || "");
      }
      headers.set("Accept", "application/json");
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    addToCart: builder.mutation({
      query: (body) => ({
        url: "user/cart/add-to-cart",
        method: "POST",
        body,
      }),
    }),

    addToWishlist: builder.mutation({
      query: (body) => ({
        url: "user/wishlist/add-to-wishlist",
        method: "POST",
        body,
      }),
    }),

    getWishlist: builder.query({
      query: () => ({
        url: "/user/wishlist/display-wishlist", // your wishlist endpoint
        method: "GET",
      }),
    }),

    removeFromWishlist: builder.mutation({
      query: (body) => ({
        url: "user/wishlist/remove-product",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useAddToCartMutation,
  useAddToWishlistMutation,
  useGetWishlistQuery,
  useRemoveFromWishlistMutation,
} = AddToCartAPI;
